import { Button, Meta, theme } from 'aimo-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyledWrapper } from 'styles/ContainerStyles';
import { useUiStore } from 'stores/uiStore';

const LimitReachModalContent = () => {
  const { t } = useTranslation();

  const handleConfirmCancel = () => {
    useUiStore.getState().setSheetModal('');
  };

  return (
    <StyledWrapper mb={0}>
      <StyledWrapper mb={60} center testID="item-unavailable-description">
        <Meta center color={theme.colors.gray300}>
          {t('services.limitReach')}
        </Meta>
      </StyledWrapper>
      <Button
        testID="item-unavailable-cancel"
        text={t('button.close')}
        size="l"
        buttonType="secondary"
        onPress={handleConfirmCancel}
      />
    </StyledWrapper>
  );
};

export default LimitReachModalContent;
